module.exports = __webpack_public_path__ + "img/loading.53f48e55.gif";